var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.pre_show),expression:"pre_show"}],staticClass:"pre-label"},[_c('label',{staticClass:"pre-title"},[_vm._v(_vm._s(_vm.pre_item.name)+":")]),_c('div',{staticClass:"pre-html",class:_vm.swichClass(_vm.pre_item),domProps:{"innerHTML":_vm._s(_vm.pre_item.val)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }